<!--
    SeeAllTestsPage.vue
    Show a list of all tests in the database.
    by Guy E. White <guw968@g.harvard.edu>
-->

<template>
    <div id='tests'>
        <h2>See All Tests</h2>
        <show-test
            v-for='test in tests'
            :key='test.id'
            :test='test'
        ></show-test>
    </div>
</template>

<script>
import ShowTestsMinimal from '@/components/ShowTestsDetailed.vue';

export default {
    name: '',
    components: {
        'show-test': ShowTestsMinimal
    },
    props: [],
    data: function() {
        return {

        };
    },
    mounted: function() {

    },
    computed: {
        tests: function() {
            return this.$store.state.products;
        }
    }
};
</script>

<style scoped>
</style>
